import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ToastAlertService } from '@core/services';
import { WorkerWorkPlaceGroupModalComponent } from '../../../components/modals/groups/worker-work-place-group-modal/worker-work-place-group-modal.component';
import { WorkerGroupUserAssignment } from '../../../models/worker-group-user-assignment.model';
import { WorkerGroup } from '../../../models/worker-group.model';
import { WorkerWorkPlaceGroup } from '../../../models/worker-work-place-group.model';
import {
  BusinessService,
  ConfigService,
  UserGroupService,
  UserService,
  WorkerWorkplaceGroupService,
} from '../../../services';
import { ModalAlertComponent } from '@shared/components';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { Cookies } from 'typescript-cookie';

@Component({
  templateUrl: './worker-work-place-group-page.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
  ],
})
export class WorkerWorkPlaceGroupPageComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private dialog = inject(MatDialog);
  private workerGroupService = inject(UserGroupService);
  private workerWokService = inject(WorkerWorkplaceGroupService);
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);
  public icon = 'add';
  fielInput!: string;
  groups: WorkerGroup[] = [];
  dataSource: MatTableDataSource<WorkerWorkPlaceGroup>;
  displayedColumns: string[] = ['name', 'description', 'options'];

  //DATA
  private businessId: number | null | undefined;
  public selectedBussines = -1;
  public bussines: any[] = [];

  public isSysAdmin = inject(ConfigService).isSysAdmin;
  private userService = inject(UserService);
  private businessService = inject(BusinessService);

  idSelected = 0;

  constructor() {
    this.dataSource = new MatTableDataSource();
  }
  ngOnInit(): void {
    this.loadworkers();
  }
  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }

  loadworkers() {
    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessId = parseInt(business.toString());
      this.selectedBussines = this.businessId;
    } else {
      this.businessId = null;
    }

    this.getBusiness();
    this.chargueGroupUsers();
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      // .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
          }
        },
      });
  }

  modalAction(idGroupWork?: number, idGroupUser?: number) {
    if (this.selectedBussines === -1) {
      this.alertService.error('Por favor selecciona una empresa.');
    } else {
      const assignment: WorkerGroupUserAssignment = {
        idGroup: idGroupWork || 0,
        idUser: idGroupUser || 0,
      };
      const dialogActionDetail = this.dialog.open(
        WorkerWorkPlaceGroupModalComponent,
        {
          width: idGroupWork ? '65rem' : '65rem',
          height: idGroupWork ? '35rem' : '35rem',
          maxWidth: 'none',
          data: {
            action: assignment,
            businessId: this.selectedBussines,
          },
          disableClose: true,
        }
      );
      dialogActionDetail
        .beforeClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result[0]) {
            this.chargueDataGroup(Number(result[1]));
          }
        });
    }
  }

  public chargueGroupUsers() {
    this.workerGroupService
      .getUserGroups(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.groups = resp.reply;
          } else {
            // this.alertService.error(resp.detail);
            console.log('el de chargueGroupUsers', resp.detail);
          }
        },
      });
  }

  //*Grupo de usuario
  chargueDataGroup(id: number) {
    console.log(id);
    this.idSelected = id;
    this.dataSource = new MatTableDataSource();
    this.workerGroupService
      .getUserGroup(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          console.log(resp);
          if (resp.code === 10000) {
            console.log('reply', resp.reply);
            this.dataSource = new MatTableDataSource(
              resp.reply.workplaceGroups
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            // this.alertService.error(resp.detail);
          }
        },
      });
  }

  modalDelete(idGroupUser: number, idGroupWork: number, name: string) {
    // console.log('data idGroupUser', idGroupUser);
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: name,
      disableClose: true,
    });
    dialogDelete.afterClosed().subscribe((result: boolean) => {
      if (!result) return;
      this.workerWokService
        .deleteWorkerWorplaceGroup(
          idGroupUser,
          idGroupWork,
          this.selectedBussines
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.alertService.sucess('Grupos de usuarios eliminado');
              this.chargueDataGroup(this.idSelected);
            } else {
              this.alertService.error(resp.detail);
              console.log('modaldeleete mensaje', resp.detail);
            }
          },
        });
    });
  }
}
